import styled from "@emotion/styled";
import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Select,
  Spin,
  Upload,
} from "antd";
import Button from "atoms/Button";
import { CALL_API } from "common/API";
import { displayErrorModal } from "common/common";
import { NON_EMPTY_REGEX, STATUS_CODE } from "common/Constants";
import { concat, find, get, includes, intersection, result } from "lodash";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { setLeaveList } from "redux/actions";
import {
  getAllDepartmentList,
  getClientid,
  getLeaveCategoryList,
  getLeaveList,
  getRoleList,
  getSelectedDepartmentId,
  getUserInfo,
  getUserList,
  getUserRoleId,
} from "redux/selectors";
import {
  addDaysinDate,
  getKenyanDateTime,
  getMySqlDate,
  momentDate,
} from "utils/Date";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";
import { CloseOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { ReactComponent as Fileupload } from "../../src/assets/File_Upload.svg";

const StyledModal = styled(Modal)`
  .custom-upload .ant-upload {
    width: 100%;
  }

  .upload-box {
    width: 100%;
    height: 42px;
    border-radius: 12px;
    background: #cfd6ff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    cursor: pointer;
    border: 1px solid #cfd6ff;
  }

  .upload-box:hover {
    background: #bcc6ff;
  }
  .ant-modal-header {
    border-bottom: none;
    padding-top: 20px;
    padding-bottom: 30px;
  }
  .ant-modal-title {
    font-weight: bold;
    font-weight: 1.2rem;
  }
  .ant-modal-body {
    padding-top: 0px;
  }
  .ant-modal-footer {
    display: none;
  }
  .ant-form-item-label {
    font-weight: 500;
  }
  .ant-picker,
  .ant-input-number {
    width: 100%;
  }
`;

const StyledButton = styled(Button)`
  width: 120px;
  border-radius: 5px;
  width: initial;
`;

const StyledFooterDiv = styled.div`
  padding-top: 30px;
`;

// Fracht Kenya: every Saturday inside a leave period counts as half a day.
const countSaturdays = (startDate, endDate) => {
  if (!startDate || !endDate) return 0;
  const day = moment(startDate).startOf("day");
  const end = moment(endDate).startOf("day");
  let count = 0;
  while (day.isSameOrBefore(end, "day")) {
    if (day.day() === 6) count++;
    day.add(1, "d");
  }
  return count;
};

function LeaveForm({
  isModalVisible,
  closeModal,
  leaveCategoryList,
  leaveDetails,
  ClientId,
  AllDepartmentList,
  // userRoleId,
  roleList,
  userInfo,
  userList,
  setLeaveListData,
  selectedDepartmentId,
  editLeaveDisable,
}) {
  const { t } = useTranslation();
  const HigherOfficialsList = userInfo?.higherOfficialsList;
  const isHR =
    HigherOfficialsList?.find((item) => item.role?.toUpperCase() === "HR")
      ?.email === userInfo?.userid;
  const [showLoader, toggleLoader] = useState(false);
  const [leaveBalance, setLeaveBalance] = useState(null);
  const [showLeaveValidationLoader, toggleLeaveValidationLoader] =
    useState(false);
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [isCancelRequest, setCancelRequest] = useState(false);
  const [form] = Form.useForm();
  const attachmentList = Form.useWatch("attachment", form);
  const [halfDay, setHalfDay] = useState(false);
  const [showHalfDayCheckbox, setShowHalfDayCheckbox] = useState(true);

  // Saturdays in the leave count as half a day each; the backend (save-leave)
  // calculates the number of days, the form only reflects it.
  const watchedStartDate = Form.useWatch("start_date", form);
  const watchedEndDate = Form.useWatch("end_date", form);
  const isSaturdayHalfDay = countSaturdays(watchedStartDate, watchedEndDate) > 0;
  const { TextArea } = Input;
  const containerRef = useRef(null);
  const [fileData, setFileData] = useState([]);

  const hasInitializedRef = useRef(false);

  const filteruser = userList?.filter(
    (item) => item.userid === form.getFieldValue("userid")
  );


  const userRoleId = filteruser[0]?.roleid?.[0];

  const leave_type = form.getFieldValue("leave_type");
  const reliever = leaveCategoryList?.find(
    (item) => item?.leave_category_id === leave_type
  )?.reliever;
  const isAnnualLeave = leaveCategoryList
    ?.find((item) => item?.leave_category_id === leave_type)
    ?.leave_category_name?.toLowerCase()
    ?.includes("annual");

  const FindName = (userid) => {
    const finduser = userList?.find((val) => val?.userid === userid);
    return finduser?.fullname;
  };

  const filterRoleList = roleList?.filter(
    (item) => item?.roleId === userRoleId
  );
  const filterDepartmentId = filterRoleList[0]?.department;
  const filterDepartment = AllDepartmentList?.filter((item) =>
    filterDepartmentId?.includes(item?.department_id)
  );

  const getFilteredCategoriesForUser = (userid) => {
    const selectedUser = userList?.find((item) => item.userid === userid);
    const selectedRoleId = selectedUser?.roleid?.[0];
    const selectedRoleList = roleList?.filter(
      (item) => item?.roleId === selectedRoleId
    );
    const selectedLocationId = selectedRoleList?.[0]?.locationId;

    const categories = [];
    leaveCategoryList?.forEach((item) => {
      if (item?.locationId?.length > 0) {
        if (intersection(item?.locationId, selectedLocationId).length > 0) {
          categories.push(item);
        }
      }
    });

    const gender = selectedUser?.gender;
    return gender?.toLowerCase() === "male"
      ? categories?.filter((item) => item.eligible?.toLowerCase() !== "female")
      : categories?.filter((item) => item.eligible?.toLowerCase() !== "male");
  };

  const resetForm = () => {
    setShowHalfDayCheckbox(true);
    setLeaveBalance(null);
    form.setFieldsValue({
      leave_id: "",
      start_date: momentDate(new Date()),
      end_date: momentDate(new Date()),
      number_of_days: 1,
      leave_type: filteredCategoriesbygender[0]?.leave_category_id,
      description: "",
      userid: userInfo?.userid,
      attachment: [],
    });
  };

  useEffect(() => {
        if (hasInitializedRef.current) return;
    if (!leaveCategoryList?.length) return;

    hasInitializedRef.current = true;

    resetForm();
  }, [userRoleId, leaveCategoryList]);

  const resetHalfDay = () => {
    setHalfDay(false);
    form.setFieldsValue({ number_of_days: 1 });
  };

  const updateHalfDay = (halfday) => {
    const { number_of_days } = form.getFieldsValue();
    const roundedDays = number_of_days;
    if (halfday === true) {
      if (number_of_days >= 0.5) {
        form.setFieldsValue({
          number_of_days: roundedDays - 0.5,
        });
      }
    } else {
      if (number_of_days >= 0.5) {
        form.setFieldsValue({
          number_of_days: Math.ceil(roundedDays),
        });
      }
    }
  };

  useEffect(() => {
    if (isModalVisible) {
      if (
        moment(leaveDetails?.end_date).format("dddd") === "Saturday" &&
        moment(leaveDetails?.start_date).format("dddd") === "Saturday" &&
        moment(leaveDetails?.start_date).format("L") ===
          moment(leaveDetails?.end_date).format("L")
      ) {
        setShowHalfDayCheckbox(false);
      } else {
        setShowHalfDayCheckbox(true);
      }
    }
  }, [isModalVisible]);

  useEffect(() => {
    const {
      user_leave_id = "",
      reason = "",
      leave_category_id,
      isViewOnly,
      isCancel = false,
      department_id = "",
      start_date,
      end_date,
      relieverid,
    } = leaveDetails;
    // const start_date =
    //   leaveDetails?.new_start_date === null ||
    //   leaveDetails?.new_start_date === "null" ||
    //   leaveDetails?.new_start_date === ""
    //     ? leaveDetails?.start_date
    //     : leaveDetails?.new_start_date;
    // const end_date =
    //   leaveDetails?.new_end_date === null ||
    //   leaveDetails?.new_end_date === "" ||
    //   leaveDetails?.new_end_date === "null"
    //     ? leaveDetails?.end_date
    //     : leaveDetails?.new_end_date;
    const number_of_days =
      leaveDetails?.new_number_of_days === null ||
      leaveDetails?.new_number_of_days === "null" ||
      leaveDetails?.new_number_of_days === ""
        ? leaveDetails?.number_of_days
        : leaveDetails?.new_number_of_days;
    console.log("number_of_days--->", number_of_days);
    if (user_leave_id !== "") {
      setIsViewOnly(isViewOnly);
      setCancelRequest(isCancel);

      form.setFieldsValue({
        leave_id: user_leave_id,
        start_date: momentDate(start_date),
        end_date: momentDate(end_date),
        number_of_days: number_of_days,
        leave_type: leave_category_id,
        description: reason,
        remark: "",
        department: department_id,
        relieverid: relieverid,
        userid: leaveDetails?.userid,
        attachment: leaveDetails?.fileName
          ? [
              {
                uid: "-1",
                name: leaveDetails.fileName,
                status: "done",
                url: leaveDetails.fileUrl || "",
              },
            ]
          : [],
      });
      if (
        !isNaN(parseFloat(number_of_days)) &&
        number_of_days.toString().includes(".") &&
        countSaturdays(start_date, end_date) === 0
      ) {
        setHalfDay(true);
      } else {
        setHalfDay(false);
      }
    } else if (start_date && end_date) {
      setCancelRequest(isCancel);
      form.setFieldsValue({
        start_date: momentDate(start_date),
        end_date: momentDate(end_date),
        leave_id: "",
        number_of_days: 1,
        leave_type: filteredCategoriesbygender[0]?.leave_category_id,
        description: "",
        remark: "",
        department: "",
        userid: userInfo?.userid,
      });
      setHalfDay(false);
    }
  }, [leaveDetails, isModalVisible]);

  function getDates() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();

    const startDate = new Date(currentYear - 2, 0, 1);
    const endDate = new Date(currentYear + 1, 11, 31);

    return {
      startDate,
      endDate,
    };
  }

  const dates = getDates();

  const getLeaveList = async () => {
    return new Promise(async (resolve, reject) => {
      if (selectedDepartmentId) {
        const { code, leaves = [] } = await CALL_API(
          `leave-list/${ClientId}`,
          "post",
          {
            status_id: "4",
            start_date: dates.startDate,
            end_date: dates.endDate,
          }
        );

        if (
          includes([STATUS_CODE.SUCCESS, STATUS_CODE.RECORD_NOT_FOUND], code)
        ) {
          setLeaveListData(leaves.reverse());

          resolve(leaves);
        } else {
          reject([]);
        }
      } else {
        reject();
      }
    });
  };

  const handleDocumentSubmit = async (file) => {
    try {
      const initPayload = {
        filename: file.name,
        type: file.type,
      };

      const res = await CALL_API(
        `save-leave/${ClientId}?requestType=file`,
        "POST",
        initPayload
      );

      if (res?.code !== STATUS_CODE.SUCCESS) {
        throw new Error("Failed to get upload url");
      }

      const uploadUrl = res?.url;
      const key = res?.key;

      if (!uploadUrl) throw new Error("Upload URL missing");

      const putRes = await fetch(uploadUrl, {
        method: "PUT",
        headers: {
          "Content-Type": file.type || "application/octet-stream",
        },
        body: file,
      });

      if (!putRes.ok) throw new Error("Upload failed");

      return key;
    } catch (err) {
      message.error(t("File upload failed"));
      return "";
    }
  };

  // Note: First params is needed
  const onFinish = async (values, saveLeave = true) => {
    if (saveLeave) toggleLoader(true);
    else toggleLeaveValidationLoader(true);
    const {
      start_date,
      end_date,
      number_of_days,
      leave_type,
      description,
      remark,
      relieverid,
      userid,
    } = form.getFieldsValue();
    const filterleavetype = leaveCategoryList?.filter(
      (item) => item.leave_category_id === leave_type?.toString()
    );
    const saturdayHalfDays = countSaturdays(start_date, end_date);
    // The Saturday half day replaces the manual half day option.
    if (saturdayHalfDays > 0 && halfDay) setHalfDay(false);
    const finduser = userList?.find((item) => item?.userid === userid);
    console.log("leave_type--->", leave_type);
    const deptName = result(
      find(AllDepartmentList, (e) => {
        return finduser?.basedepartmentid?.includes(e.department_id);
      }),
      "department_name"
    );
    const fileList = values?.attachment || [];
    const fileObj = fileList?.[0]?.originFileObj || null;

    let uploadedKey = leaveDetails?.objectKey || "";
    let fileName = leaveDetails?.fileName || "";

    // If user removed the existing attachment
    if (saveLeave && fileList.length === 0) {
      uploadedKey = "";
      fileName = "";
    }

    // Upload only while saving the leave
    if (saveLeave && fileObj) {
      const videoTypes = [
        "video/mp4",
        "video/mpeg",
        "video/quicktime",
        "video/x-msvideo",
        "video/x-ms-wmv",
        "video/webm",
        "video/ogg",
      ];

      if (
        videoTypes.includes(fileObj.type) ||
        fileObj.type?.startsWith("video/")
      ) {
        message.error(t("Video files are not allowed"));
        toggleLoader(false);
        return;
      }

      uploadedKey = await handleDocumentSubmit(fileObj);

      if (!uploadedKey) {
        toggleLoader(false);
        return;
      }

      fileName = fileObj.name;
    }
    const { user_leave_id = "" } = leaveDetails;
    const relievername = userList?.find(
      (item) => item?.userid === relieverid
    )?.fullname;
    // FIX: guard against leave_type being undefined/null (not just "").
    // Previously `if (leave_type !== "")` let `undefined` through and
    // crashed on `leave_type.toString()` below.
    if (leave_type) {
      const { code, leaveBalance, totalNumberOfDaysInLeave, reason } =
        await CALL_API(`save-leave/${ClientId}`, "post", {
          leave_id: user_leave_id,
          start_date: getMySqlDate(start_date),
          end_date: getMySqlDate(end_date),
          // The backend treats a decimal number_of_days as a manual half day.
          // When recalculating, send whole days unless half day is ticked, so a
          // leftover 0.5 (e.g. from a previous Saturday range) isn't deducted.
          number_of_days:
            !saveLeave && !halfDay
              ? Math.ceil(Number(number_of_days)) || 1
              : number_of_days,
          leave_category_id: leave_type?.toString(),
          reason: description,
          decline_reason: isCancelRequest ? remark : "",
          is_cancel_request: isCancelRequest,
          isSaving: saveLeave,
          reporting_manager: finduser?.reportingmanager,
          reporting_manager_name: FindName(finduser?.reportingmanager),
          old_number_of_day: leaveDetails?.number_of_days
            ? leaveDetails?.number_of_days
            : "",
          holiday: filterleavetype[0]?.holiday?.length
            ? filterleavetype[0]?.holiday
            : "No",
          weekend: filterleavetype[0]?.weekend?.length
            ? filterleavetype[0]?.weekend
            : "No",
          isSaturday: filterleavetype[0]?.isSaturday?.length
            ? filterleavetype[0]?.isSaturday
            : "No",
          employeeid: filteruser[0]?.employeeid,
          leave_category_name: get(
            find(filteredCategoriesbygender, {
              leave_category_id: leave_type?.toString(),
            }),
            "leave_category_name",
            ""
          ),
          fullname: filteruser[0]?.fullname,
          halfday: halfDay === true || saturdayHalfDays > 0 ? "Yes" : "No",
          department_name: deptName,
          department_id: finduser?.basedepartmentid,
          relieverid: reliever ? relieverid : "",
          relievername: reliever ? relievername : "",
          userId: userid,
          ...(saveLeave && {
            objectKey: uploadedKey,
            fileName,
          }),
        });
      const payloadVariable = {
        leave_id: user_leave_id,
        start_date: getMySqlDate(start_date),
        end_date: getMySqlDate(end_date),
        number_of_days,
        leave_category_id: leave_type,
        reason: description,
        decline_reason: isCancelRequest ? remark : "",
        is_cancel_request: isCancelRequest,
        isSaving: saveLeave,
      };
      if (saveLeave) toggleLoader(false);
      else toggleLeaveValidationLoader(false);
      if (code === STATUS_CODE.SOMETHING_WENT_WRONG) {
        message.error(`Oops!! something went wrong`);
      } else if (code === STATUS_CODE.INVALID_PAYLOAD) {
        if (
          filterleavetype[0]?.holiday === "No" &&
          filterleavetype[0]?.weekend === "No"
        ) {
          message.error(`You cannot apply for leave on Holidays and Sundays`);
        } else if (filterleavetype[0]?.holiday === "No") {
          message.error(`You cannot apply for leave on Holidays`);
        } else if (filterleavetype[0]?.weekend === "No") {
          message.error(`You cannot apply for leave on Sundays`);
        } else {
          message.error(`Invalid payload. Please enter correct data`);
        }
      } else if (code === STATUS_CODE.RECORD_EXIST) {
        message.error(`Leave already exists`);
      } else if (code === STATUS_CODE.ANNUAL_LEAVE_AVAILABLE) {
        message.error(
          `You can not apply compassionate leave. You still have annual leaves.`
        );
      } else if (code === STATUS_CODE.SICK_LEAVE_AVAILABLE) {
        message.error(
          `You can not apply sick leave(half-pay). You still have sick leaves.`
        );
      } else if (code === STATUS_CODE.LEAVE_EXCEED) {
        form.setFieldsValue({
          number_of_days:
            totalNumberOfDaysInLeave === 0 ? 1 : totalNumberOfDaysInLeave,
        });
        displayErrorModal(
          `You are exceeding your leave quota. your current leave balance is ${leaveBalance}`
        );
      } else if (code === STATUS_CODE.SUCCESS) {
        if (saveLeave) {
          message.success(
            isCancelRequest
              ? t("Request has been submitted")
              : `${t(
                  "Leave has been " + (user_leave_id ? "updated" : "applied")
                )}`
          );
          form.resetFields();
          closeModal(true);
          setShowHalfDayCheckbox(true);
          getLeaveList();
        } else {
          form.setFieldsValue({
            number_of_days:
              totalNumberOfDaysInLeave === 0 ? 1 : totalNumberOfDaysInLeave,
          });
        }
      }
      if (leaveBalance !== undefined && leaveBalance !== null) {
        setLeaveBalance(leaveBalance);
      }
    } else {
      message.error("kindly select the leave type");
      toggleLeaveValidationLoader(false);
    }
  };

  const restrictPastDate = (current, element) => {
    let customDate = moment("2022-08-01").format("YYYY-MM-DD");
    if (element === "end_date") {
      return current < moment(form.getFieldValue("start_date"));
    }
    return current && current < moment(customDate, "YYYY-MM-DD");
  };

  const validateDateRange = () => {
    const endDate = moment(form.getFieldValue("end_date"));
    const startDate = moment(form.getFieldValue("start_date"));
    if (endDate < startDate) {
      form.setFieldsValue({ end_date: startDate });
      onFinish({}, false);
    } else {
      onFinish({}, false);
    }
  };

  const dateChange = () => {
    onFinish({}, false);
    updateHalfDay();
  };

  const hideHalfDay = () => {
    const { start_date, end_date } = form.getFieldsValue();
    if (
      moment(end_date).format("dddd") == "Saturday" &&
      moment(start_date).format("dddd") == "Saturday" &&
      moment(start_date).format("L") == moment(end_date).format("L")
    ) {
      setShowHalfDayCheckbox(false);
    } else {
      setShowHalfDayCheckbox(true);
    }
  };

  const updateEndDate = () => {
    const { start_date, number_of_days } = form.getFieldsValue();
    if (number_of_days >= 1) {
      const roundedDays = Math.ceil(number_of_days);
      form.setFieldsValue({
        number_of_days: roundedDays,
        end_date: momentDate(addDaysinDate(start_date, roundedDays - 1)),
      });
    }
  };

  const checkBoxStyle = {
    marginTop: "55px",
    position: "relative",
    bottom: "15px",
  };

  const finduser = userList?.find((item) => item?.userid === userInfo?.userid);
  console.log("finduser--->", finduser);

  const filterrolelist = roleList?.filter((val) => val?.roleId === userRoleId);
  const filterdepartmentid = filterrolelist[0]?.department;
  const filterlocationid = filterrolelist[0]?.locationId;

  const filterleaves = [];
  leaveCategoryList?.forEach((item) => {
    if (item?.locationId?.length > 0) {
      if (item?.locationId?.includes(finduser?.baselocationid)) {
        filterleaves.push(item);
      }
    }
  });

  // const filteruser = userList?.filter(
  //   (item) => item.userid === userInfo?.userid
  // );
  const filtergender = filteruser[0]?.gender;
  const filteredCategoriesbygender =
    filtergender?.toLowerCase() === "male"
      ? filterleaves?.filter(
          (item) => item.eligible?.toLowerCase() !== "female"
        )
      : filterleaves?.filter((item) => item.eligible?.toLowerCase() !== "male");

  useEffect(() => {
    if (!isModalVisible) return;

    // Don't run for edit/view mode
    if (leaveDetails?.user_leave_id) return;

    requestAnimationFrame(() => {
      const leaveType = form.getFieldValue("leave_type");

      if (leaveType) {
        onFinish({}, false);
      }
    });
  }, [isModalVisible]);

  return (
    <StyledModal
      title={t("Leave Details")}
      visible={isModalVisible}
      onCancel={() => {
        closeModal(false);
        resetHalfDay();
        resetForm();
      }}
      width={600}
      footer={[]}
    >
      <Form
        form={form}
        name="leaveform"
        layout="vertical"
        initialValues={{
          leave_id: "",
          start_date: momentDate(getKenyanDateTime()),
          end_date: momentDate(getKenyanDateTime()),
          number_of_days: 1,
          leave_type: filteredCategoriesbygender[0]?.leave_category_id,
          description: "",
          remark: "",
          userid: "",
        }}
        onFinish={onFinish}
      >
        <Row gutter={20}>
          {leaveBalance !== null && (
            <Col xs={24}>
              <div
                style={{
                  marginBottom: 16,
                  padding: "8px 12px",
                  borderRadius: 8,
                  background: "#EFF6FF",
                  border: "1px solid #BFDBFE",
                  fontSize: 13,
                  color: "#1e3a8a",
                }}
              >
                {t("Available Leave Balance")}: <strong>{leaveBalance}</strong>{" "}
                {t("day(s)")}
              </div>
            </Col>
          )}
           <Col xs={24} sm={24} md={24} ref={containerRef}>
            <Form.Item
              name="userid"
              label={t("Employee Name")}
              rules={[
                {
                  required: userList?.length !== 0 ? true : false,
                  pattern: NON_EMPTY_REGEX,
                  message: t("Employee Name is required"),
                },
              ]}
            >
              <Select
                className="selectbox mb-2"
                disabled={isHR ? false : true}
                showSearch
                placeholder={t("Select User")}
                options={userList?.filter((item) => item?.statusid === "1")}
                fieldNames={{ label: "fullname", value: "userid" }}
                filterOption={(input, option) =>
                  (option.fullname ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                filterSort={(a, b) =>
                  (a.fullname ?? "")
                    .toLowerCase()
                    .localeCompare((b.fullname ?? "").toLowerCase())
                }
                onChange={(value) => {
                  // Recompute the eligible leave categories for the
                  // newly selected user, and reset leave_type so we
                  // don't keep a category that may not apply to them.
                  const newCategories = getFilteredCategoriesForUser(value);
                  form.setFieldsValue({
                    leave_type: newCategories?.[0]?.leave_category_id,
                  });
                  validateDateRange();
                }}
                getPopupContainer={() => containerRef.current}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={24} ref={containerRef}>
            <Form.Item
              label={t("Leave Type")}
              name="leave_type"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: t("Leave type is required"),
                },
              ]}
            >
              <Select
                showSearch
                placeholder={t("Search leave type")}
                name="leave_type"
                optionFilterProp="leave_category_name"
                filterOption={(input, option) =>
                  option.leave_category_name
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                filterSort={(optionA, optionB) => {
                  optionA.leave_category_name
                    .toLowerCase()
                    .localeCompare(optionB.leave_category_name.toLowerCase());
                }}
                options={filteredCategoriesbygender}
                fieldNames={{
                  label: "leave_category_name",
                  value: "leave_category_id",
                }}
                disabled={
                  (leaveDetails?.status_id === "5" &&
                    leaveDetails?.having_cancel_request === "0") ||
                  halfDay
                    ? true
                    : isViewOnly
                }
                onChange={() => validateDateRange()}
                getPopupContainer={() => containerRef.current}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              label={t("Start Date")}
              name="start_date"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: t("Start date is required"),
                },
                () => ({
                  // Note: First param is needed
                  validator(rule, value) {
                    const date = moment(value);
                    return date.isValid()
                      ? Promise.resolve()
                      : Promise.reject();
                  },
                }),
              ]}
            >
              <DatePicker
                format="DD-MM-YYYY"
                onChange={() => {
                  validateDateRange();
                  hideHalfDay();
                }}
                // disabledDate={(current) => current && current < moment().startOf('day')}
                disabled={
                  !form.getFieldValue("leave_type") || isViewOnly || halfDay
                }
                getPopupContainer={() => containerRef.current}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, currentValues) =>
                prevValues.start_date !== currentValues.start_date
              }
            >
              {() => (
                <Form.Item
                  label={t("End Date")}
                  name="end_date"
                  rules={[
                    {
                      required: true,
                      pattern: NON_EMPTY_REGEX,
                      message: t("End date is required"),
                    },
                    () => ({
                      // first parameter is needed
                      validator(rule, value) {
                        const date = moment(value);
                        return date.isValid()
                          ? Promise.resolve()
                          : Promise.reject();
                      },
                    }),
                  ]}
                >
                  <DatePicker
                    disabledDate={(current) =>
                      restrictPastDate(current, "end_date")
                    }
                    format="DD-MM-YYYY"
                    onChange={() => {
                      dateChange();
                      setHalfDay(false);
                      hideHalfDay();
                    }}
                    disabled={
                      !form.getFieldValue("leave_type") || isViewOnly || halfDay
                    }
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              )}
            </Form.Item>
          </Col>

          <Col xs={24} sm={24} md={12}>
            <Spin spinning={showLeaveValidationLoader}>
              <Form.Item label={t("No. of Days")} name="number_of_days">
                <InputNumber min={0.5} onChange={updateEndDate} disabled />
              </Form.Item>
            </Spin>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Checkbox
              style={checkBoxStyle}
              checked={halfDay || isSaturdayHalfDay}
              disabled={isSaturdayHalfDay}
              onChange={(e) => {
                updateHalfDay(!halfDay);
                setHalfDay((prevCheck) => !prevCheck);
              }}
            >
              {t("Half day")}
              {isSaturdayHalfDay ? ` (${t("Saturday")})` : ""}
            </Checkbox>
          </Col>
          <Col xs={24} sm={24} md={24} ref={containerRef}>
            {reliever === "Yes" && (
              <Form.Item
                label={t("Reliever Name")}
                name="relieverid"
                rules={[
                  {
                    required: false,
                    message: t("Reliever Name is required"),
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder={t("Search leave type")}
                  optionFilterProp="fullname"
                  filterOption={(input, option) =>
                    option.fullname.toLowerCase().includes(input.toLowerCase())
                  }
                  filterSort={(optionA, optionB) => {
                    optionA.fullname
                      .toLowerCase()
                      .localeCompare(optionB.fullname.toLowerCase());
                  }}
                  options={userList?.filter((item) => item?.statusid === "1")}
                  fieldNames={{
                    label: "fullname",
                    value: "userid",
                  }}
                  // disabled={
                  //   (leaveDetails?.status_id === "5" &&
                  //     leaveDetails?.having_cancel_request === "0") ||
                  //   halfDay
                  //     ? true
                  //     : isViewOnly
                  // }
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
            )}
          </Col>

          {/* <Col xs={24} sm={24} md={12} ref={containerRef}>
            <Form.Item
              label="Department"
              name="department"
              rules={[
                {
                  required: true,
                  pattern: NON_EMPTY_REGEX,
                  message: "Department is required",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Select Department"
                name="department"
                options={concat(
                  {
                    department_id: "",
                    department_name: "Select Department",
                  },
                  filterDepartment
                )}
                fieldNames={{
                  label: "department_name",
                  value: "department_id",
                }}
                disabled={isViewOnly || editLeaveDisable}
                getPopupContainer={() => containerRef.current}
              />
            </Form.Item>
          </Col> */}
        </Row>{" "}
        {!isViewOnly && (
          <div>
            {isCancelRequest && (
              <Form.Item shouldUpdate>
                {({ getFieldValue }) => {
                  const leave_type = getFieldValue("leave_type");
                  return (
                    leave_type !== true && (
                      <Form.Item
                        label={t("Detailed Reason")}
                        name="description"
                        rules={[
                          {
                            required: false, // was: true
                            pattern: NON_EMPTY_REGEX,
                            message: t("Leave reason is required"),
                          },
                        ]}
                      >
                        <TextArea
                          placeholder={t("Type something")}
                          maxLength={500}
                          disabled={isViewOnly}
                          autoSize={{ minRows: 2, maxRows: 6 }}
                        />
                      </Form.Item>
                    )
                  );
                }}
              </Form.Item>
            )}
            {!isCancelRequest && (
              <Form.Item shouldUpdate>
                {({ getFieldValue }) => {
                  const leave_type = getFieldValue("leave_type");
                  return (
                    leave_type !== true && (
                      <Form.Item
                        label={t("Detailed Reasons")}
                        name="description"
                        rules={[
                          {
                            required:
                              form.getFieldValue("leave_type") &&
                              !isAnnualLeave, // added !isAnnualLeave
                            pattern: NON_EMPTY_REGEX,
                            message: t("Reason is required"),
                          },
                        ]}
                      >
                        <TextArea
                          placeholder={t("Type something")}
                          maxLength={500}
                          disabled={isViewOnly}
                          autoSize={{ minRows: 2, maxRows: 6 }}
                        />
                      </Form.Item>
                    )
                  );
                }}
              </Form.Item>
            )}
          </div>
        )}
        <Form.Item
          label={t("Attachment (Optional)")}
          name="attachment"
          valuePropName="fileList"
          getValueFromEvent={(e) => e?.fileList}
        >
          <Upload
            beforeUpload={() => false}
            maxCount={1}
            className="custom-upload"
          >
            {!attachmentList?.length && (
              <div className="upload-box">
                <UploadOutlined />
                <span style={{ marginLeft: 8 }}>{t("Upload File")}</span>
              </div>
            )}
          </Upload>
        </Form.Item>
        {!isViewOnly && (
          <StyledFooterDiv className="align-right">
            {!isCancelRequest && (
              <StyledButton
                type="primary"
                onClick={() => {
                  resetForm();
                  resetHalfDay();
                }}
                disabled={showLeaveValidationLoader}
              >
                {t("Reset All")}
              </StyledButton>
            )}
            <StyledButton
              loading={showLoader}
              type="primary"
              htmlType="submit"
              disabled={showLeaveValidationLoader}
            >
              {showLoader ? t("Submitting") : t("Submit")}
            </StyledButton>
          </StyledFooterDiv>
        )}
      </Form>
    </StyledModal>
  );
}

const mapStateToProps = (state) => ({
  leaveCategoryList: getLeaveCategoryList(state),
  userInfo: getUserInfo(state),
  ClientId: getClientid(state),
  AllDepartmentList: getAllDepartmentList(state),
  userRoleId: getUserRoleId(state),
  roleList: getRoleList(state),
  userList: getUserList(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  leaveList: getLeaveList(state),
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setLeaveListData: setLeaveList,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(LeaveForm);